import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const Table = () => (
  <ComponentDocs
    name="<Table/>"
    entry="Table"
    propsEntry="TableProps"
    externalProps={ExternalProps.MuiTable}
  >
    <ComponentExample
      name="Basic table"
      import={import("examples/Tables/Table/BasicTableExample")}
      rawImport={import("examples/Tables/Table/BasicTableExample?raw")}
    />
    <ComponentExample
      name="Row click"
      import={import("examples/Tables/Table/RowClickExample")}
      rawImport={import("examples/Tables/Table/RowClickExample?raw")}
    />
    <ComponentExample
      name="Row link"
      import={import("examples/Tables/Table/RowLinkExample")}
      rawImport={import("examples/Tables/Table/RowLinkExample?raw")}
    />
    <ComponentExample
      name="Header and footer"
      import={import("examples/Tables/Table/HeaderAndFooterExample")}
      rawImport={import("examples/Tables/Table/HeaderAndFooterExample?raw")}
    />
    <ComponentExample
      name="Empty message"
      import={import("examples/Tables/Table/EmptyMessageExample")}
      rawImport={import("examples/Tables/Table/EmptyMessageExample?raw")}
    />
    <ComponentExample
      name="Expandable rows"
      import={import("examples/Tables/Table/ExpandableRowsExample")}
      rawImport={import("examples/Tables/Table/ExpandableRowsExample?raw")}
    />
    <ComponentExample
      name="Row state"
      description="A render function can be passed as the child of the table to access row state. In this mode the columns prop on the table should be specified."
      import={import("examples/Tables/Table/RowStateExample")}
      rawImport={import("examples/Tables/Table/RowStateExample?raw")}
    />
    <ComponentExample
      name="Row classes"
      import={import("examples/Tables/Table/RowClassesExample")}
      rawImport={import("examples/Tables/Table/RowClassesExample?raw")}
    />
  </ComponentDocs>
);

export default Table;
